import { useGetProfile } from "../../Controllers/UserProfileController";
import NameDisplay from "../NameDisplay";
import CircularSkeletonLoader from "../SkeletonLoaders/CircularSkeletonLoader";

const HeaderLeftUser = () => {
  const { data: profileData, isLoading: profileLoading } = useGetProfile();

  if (profileLoading) {
    return <CircularSkeletonLoader size="48px" count={1} />;
  }

  return (
    <div className="header-right-container">
      <div className="profile-image-container">
        <img
          alt="image-alt"
          className="profile-image"
          src={
            profileData?.image && profileData.image !== "null"
              ? profileData.image
              : null
          }
        />
        <div className="notification-count text-small-s2">
          {profileData?.user_level ?? 0}
        </div>
      </div>
      <div className="profile-details">
        <NameDisplay
          name={profileData?.full_name ?? null}
          textStyle={"text-body-b3"}
          maxLength={10}
        />
        <span className="text-body-b4">
          Level {profileData?.user_level ?? 0}
        </span>
      </div>
    </div>
  );
};

export default HeaderLeftUser;
